import { noop } from '@vkontakte/vkjs';
import { createContext } from 'react';
import { StatusBarStyle } from './types';

export interface StatusBarContext {
  setForcedStatusBarStyle: React.Dispatch<React.SetStateAction<StatusBarStyle | undefined>>;
}

export const StatusBarContext = createContext<StatusBarContext>({ setForcedStatusBarStyle: noop });
